import React from 'react';
import {connect} from 'react-redux';
import {Link} from 'react-router-dom';
import {Button, Card} from 'semantic-ui-react';
import {Actions} from '../../../common/actions';
import {vehiclesInventoryScreens} from '../../constants';

const Header = (props) => {
  const {screen} = props;

  return (
    <Card className='small-title-container'>
      <div className="title-bar center-vertical w-100">
        <div className="title center-vertical ">
          <h3>
            {`${screen.description}`}
          </h3>
          {screen === vehiclesInventoryScreens.vehiclesByLineTable && (
            <div className="title-bar-actions">
              {!props.createdOrder && (
                <Link to="/vehiculos/administracion-inventario">
                  <Button type="button" basic className="toyota-secondary">
                    Cerrar
                  </Button>
                </Link>
              )}
            </div>
          )}
        </div>
      </div>
    </Card>
  );
};

const mapStateToProps = (state, ownProps) => {
  return {
    'loading': state.manageOrders.loading,
  };
};
const {
  activateOrigin,
} = Actions;

export default connect(mapStateToProps, {
  activateOrigin,
})(Header);
